<div
  class="flex flex-center w-full h-full flex-col items-center justify-center min-h-full"
>
  <img src="assets/images/spinner/abert.gif" class="w-40" />
  <span class="font-semibold text-grey-700 text-2xl">{{ message }}</span>
</div>
